/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Move to Previous Insurance button
 */
import React from 'react';
import { Button, Row, Col, Typography, App, ButtonProps } from 'antd';

import { MODAL_TYPES } from '../modal';
import useDeleteCoverage from 'hooks/patients/mutate/useDeleteCoverage';

export interface IProps extends ButtonProps {
	coverageId: string;
	versionId: string;
	label?: string;
}

/**
 * Move to Previous Insurance button
 */
const MoveToPreviousInsurance: React.FC<IProps> = ({ coverageId, versionId, ...buttonProps }) => {
	const { modal } = App.useApp();
	const { mutateAsync, isPending } = useDeleteCoverage();

	const showModal = () => {
		modal.confirm({
			...MODAL_TYPES.warning,
			title: 'Archive Insurance',
			width: 560,
			content: (
				<Row gutter={[20, 20]}>
					<Col span={24}>
						<Typography.Text>
							{
								"You're about to archive this insurance. It will no longer appear in the patient's current insurance list and cannot be reactivated."
							}
						</Typography.Text>
					</Col>
					<Col span={24}>
						<Typography.Text>
							{
								'Archived insurance will remain available under Previous Insurance for historical reference and ongoing claims.'
							}
						</Typography.Text>
					</Col>
				</Row>
			),
			okText: 'Archive',
			okButtonProps: { danger: true },
			onOk: () => mutateAsync({ coverageId, versionId }),
		});
	};

	return (
		<Button danger onClick={showModal} disabled={isPending} {...buttonProps}>
			{'Archive'}
		</Button>
	);
};

export default MoveToPreviousInsurance;
